export default "__VITE_ASSET__CRd5_jh2__"